import {i as te, g as ie, a as Y, p as j} from '@theme/card-image';
import {r as re} from '@theme/request-idle-callback';
const J = 750,
  se = 700,
  M = 1250,
  Q = 3e3,
  G = 250,
  ne = 300,
  ae = 'combined-listing-card',
  f = {
    formInput: (S) => `[name="${S}"]`,
    cardImage: '.card__media img[data-model-image]',
    swatches: '.product-swatches',
    gallery: '[data-card-gallery]',
    galleryJson: '[data-card-gallery-json]',
    galleryPrev: '[data-gallery-prev]',
    galleryNext: '[data-gallery-next]',
    galleryProgress: '[data-gallery-progress]',
    galleryProgressTrack: '[data-gallery-progress-track]',
    sizeOverlayTrigger: '[data-size-overlay-trigger]',
    sizeOverlay: '[data-size-overlay]',
    sizeBackdrop: '[data-size-backdrop]',
    sizeGrid: '[data-size-grid]',
    sizeSheetHeader: '[data-size-sheet-header]',
    sizeSheetSwatches: '[data-size-sheet-swatches]',
    sizeOverlayClose: '[data-size-overlay-close]',
    sizeOption: '[data-size-option]',
  },
  v = {
    swatchActive: 'active',
    sizeOptionDisabled: 'card__size-option--disabled',
    sizeOptionLowStock: 'card__size-option--low-stock',
    overlayOpen: 'card__size-overlay--open',
    backdropOpen: 'card__size-backdrop--open',
    cardSizeOverlayOpen: 'card-wrapper--size-overlay-open',
  };
function le(S) {
  re(S, {timeout: 2e3});
}
function k(S) {
  return String(S ?? '')
    .trim()
    .toLowerCase();
}
let q;
function Z() {
  return (
    q !== void 0 ||
      (q =
        typeof IntersectionObserver == 'function'
          ? new IntersectionObserver(
              (S, e) => {
                S.forEach((t) => {
                  var i, r;
                  t.isIntersecting &&
                    (e.unobserve(t.target), (r = (i = t.target).preloadGallerySlides) == null || r.call(i));
                });
              },
              {rootMargin: '600px'}
            )
          : null),
    q
  );
}
class oe extends HTMLElement {
  constructor() {
    super(), this.initialise();
  }
  initialise() {
    return this.initialised
      ? !0
      : ((this.form = this.form || this.querySelector('form')),
        this.form
          ? (this.initGallery(), this.initSwatches(), this.initSizeOverlay(), (this.initialised = !0), !0)
          : !1);
  }
  connectedCallback() {
    const e = (this.connectionVersion || 0) + 1;
    this.connectionVersion = e;
    const t = () => {
      !this.isConnected ||
        this.connectionVersion !== e ||
        !this.initialise() ||
        this.connectionActive ||
        ((this.connectionActive = !0),
        this.galleryInitialised && document.addEventListener('plp:view-changed', this.onPlpViewChange),
        this.configureGalleryInteractions(),
        this.initSheetSwipeToDismiss(),
        this.schedulePreloadGallerySlides(),
        this.mobileMediaQuery &&
          this.onViewportChange &&
          (typeof this.mobileMediaQuery.addEventListener == 'function'
            ? this.mobileMediaQuery.addEventListener('change', this.onViewportChange)
            : this.mobileMediaQuery.addListener(this.onViewportChange)));
    };
    this.initialise() ? t() : queueMicrotask(t);
  }
  initGallery() {
    var t, i;
    if (
      this.galleryInitialised ||
      ((this.gallery = this.querySelector(f.gallery)),
      (this.cardImage = this.querySelector(f.cardImage)),
      (this.videoEl = this.querySelector('[data-card-video]')),
      (this.showingVideo = !!this.videoEl),
      !this.gallery || !this.cardImage)
    )
      return;
    const e = this.gallery.querySelector(f.galleryJson);
    if (e) {
      this.galleryInitialised = !0;
      try {
        this.galleryData = JSON.parse(e.textContent);
        const r = this.galleryData.slidesByColor || {};
        (this.gallerySlidesByColor = {}),
          Object.keys(r).forEach((s) => {
            this.gallerySlidesByColor[k(s)] = r[s];
          });
      } catch {
        (this.galleryData = {defaultColor: '', slidesByColor: {}}), (this.gallerySlidesByColor = {});
      }
      (this.galleryIndex = 0),
        (this.gallerySlides = []),
        (this.galleryProgress = this.gallery.querySelector(f.galleryProgress)),
        (this.onPlpViewChange = this.onPlpViewChange.bind(this)),
        (this.galleryPrevBtn = this.querySelector(f.galleryPrev)),
        (this.galleryNextBtn = this.querySelector(f.galleryNext)),
        (this.onGalleryPrevClick = (r) => {
          r.preventDefault(), r.stopPropagation(), this.stepGalleryOrVideo(-1);
        }),
        (this.onGalleryNextClick = (r) => {
          r.preventDefault(), r.stopPropagation(), this.stepGalleryOrVideo(1);
        }),
        (t = this.galleryPrevBtn) == null || t.addEventListener('click', this.onGalleryPrevClick),
        (i = this.galleryNextBtn) == null || i.addEventListener('click', this.onGalleryNextClick),
        this.galleryData.defaultColor && this.setGalleryForColor(this.galleryData.defaultColor),
        this.gallery.classList.toggle('card__gallery--item-view', this.cardImageView === 'item'),
        this.configureGalleryInteractions(),
        this.isConnected && document.addEventListener('plp:view-changed', this.onPlpViewChange);
    }
  }
  get isPlpToggleExcluded() {
    return te(this.dataset.productType);
  }
  get cardImageView() {
    return this.isPlpToggleExcluded ? 'model' : ie();
  }
  get galleryRenderView() {
    return 'model';
  }
  configureGalleryInteractions() {
    var e;
    this.gallery &&
      (this.gallery.classList.add('card__gallery--js'),
      this.gallery.classList.remove('card__gallery--no-swipe'),
      (e = this._galleryDragCleanup) == null || e.call(this),
      (this._galleryDragCleanup = null),
      !(this.getGalleryStepCount() < 2) && this.initGalleryDrag());
  }
  initGalleryDrag() {
    var K;
    if (this._galleryDragCleanup || !this.gallery) return;
    const e = 5,
      t = 30,
      i = 0.3,
      r = 4e3,
      s = this.querySelector('.card__media') || this.gallery,
      n = this.querySelector('.card__gallery-link'),
      a = (K = this.videoEl) == null ? void 0 : K.querySelector('a');
    let c = 0,
      l = 0,
      o = 0,
      h = null,
      y = !1,
      g = !1,
      d = !1,
      w = null,
      I = null,
      m = !1,
      b = null,
      C = null,
      P = null;
    const T = (u) => {
        var E;
        const p = s.clientWidth || ((E = this.cardImage) == null ? void 0 : E.clientWidth) || 0;
        return p ? Math.max(-p, Math.min(p, u)) : u;
      },
      O = (u) => {
        if (u && (u.target !== b || u.propertyName !== 'transform')) return;
        const p = b;
        p &&
          (p.removeEventListener('transitionend', O),
          clearTimeout(P),
          (p.style.transition = ''),
          (p.style.transform = ''),
          C && this.restoreGalleryDragPreview(C),
          (b = null),
          (C = null),
          (P = null));
      },
      _ = () => {
        O();
        const u = this._galleryDragPreview,
          p = (u == null ? void 0 : u.outgoing) || this.cardImage;
        if (!(p != null && p.style.transform)) {
          this.clearGalleryDragPreview();
          return;
        }
        if (
          ((b = p),
          (C = u),
          (this._galleryDragPreview = null),
          (p.style.transition = `transform ${G}ms ease`),
          (p.style.transform = ''),
          C)
        ) {
          const E = C.direction > 0 ? C.width : -C.width;
          (C.incoming.style.transition = `transform ${G}ms ease`), (C.incoming.style.transform = `translateX(${E}px)`);
        }
        p.addEventListener('transitionend', O), (P = window.setTimeout(O, G + 100));
      },
      L = () => {
        if (h !== null) {
          if (d)
            try {
              s.releasePointerCapture(h);
            } catch {}
          (h = null), (y = !1), (d = !1), clearTimeout(w), _();
        }
      },
      z = () => L(),
      B = () => {
        document.hidden && L();
      },
      $ = (u) => {
        if (!(u.isPrimary === !1 || (Number.isFinite(u.button) && u.button !== 0))) {
          if (u.target instanceof Element) {
            const p = u.target.closest('a, button, input, label, [data-size-overlay]');
            if (p && p !== n && p !== a) return;
          }
          h === null &&
            (O(),
            this.clearGalleryDragPreview(),
            this.finishGalleryAnimation(),
            u.stopPropagation(),
            (h = u.pointerId),
            (c = u.clientX),
            (l = u.clientY),
            (o = u.timeStamp),
            (y = !1),
            (g = !1),
            (d = !1),
            clearTimeout(w),
            (w = window.setTimeout(L, r)));
        }
      },
      H = (u) => {
        var V;
        if (u.pointerId !== h) return;
        u.stopPropagation();
        const p = u.clientX - c,
          E = u.clientY - l;
        if (
          ((Math.abs(p) > e || Math.abs(E) > e) && (g = !0),
          !y &&
            Math.abs(p) > Math.abs(E) &&
            Math.abs(p) > e &&
            ((y = !0), (V = s.setPointerCapture) == null || V.call(s, u.pointerId), (d = !0)),
          y && this.cardImage)
        ) {
          const F = T(p);
          this.updateGalleryDragPreview(F < 0 ? 1 : -1, F);
        }
      },
      N = (u) => {
        if (u.pointerId !== h) return;
        u.stopPropagation(), clearTimeout(w), (h = null), (d = !1);
        const p = u.clientX - c,
          E = u.timeStamp - o,
          V = E > 0 ? Math.abs(p) / E : 0;
        if (!g) {
          y = !1;
          return;
        }
        (m = !0),
          clearTimeout(I),
          (I = window.setTimeout(() => {
            m = !1;
          })),
          y && (Math.abs(p) > t || (V > i && Math.abs(p) > e))
            ? this.stepGalleryOrVideo(p < 0 ? 1 : -1, T(p))
            : y
              ? _()
              : this.cardImage && (this.cardImage.style.transform = ''),
          (y = !1);
      },
      R = (u) => {
        u.pointerId === h && (u.stopPropagation(), L());
      },
      U = (u) => u.preventDefault(),
      x = (u) => {
        m && ((m = !1), clearTimeout(I), u.preventDefault(), u.stopPropagation());
      };
    let A = !1;
    const ee = (u) => {
        if (!(u instanceof Element)) return !1;
        const p = u.closest('a, button, input, label, [data-size-overlay]');
        return !!p && p !== n && p !== a;
      },
      W = (u) => {
        (A = !ee(u.target)), A && u.stopPropagation();
      },
      X = (u) => {
        A && u.stopPropagation();
      },
      D = (u) => {
        A && (u.stopPropagation(), (A = !1));
      };
    s.addEventListener('pointerdown', $),
      s.addEventListener('pointermove', H),
      s.addEventListener('pointerup', N),
      s.addEventListener('pointercancel', R),
      s.addEventListener('dragstart', U),
      s.addEventListener('touchstart', W),
      s.addEventListener('touchmove', X),
      s.addEventListener('touchend', D),
      s.addEventListener('touchcancel', D),
      n == null || n.addEventListener('click', x),
      a == null || a.addEventListener('click', x),
      window.addEventListener('blur', z),
      document.addEventListener('visibilitychange', B),
      (this._galleryDragCleanup = () => {
        if (h !== null && d)
          try {
            s.releasePointerCapture(h);
          } catch {}
        (h = null),
          (y = !1),
          (d = !1),
          (m = !1),
          clearTimeout(I),
          O(),
          this.clearGalleryDragPreview(),
          this.cardImage && ((this.cardImage.style.transition = ''), (this.cardImage.style.transform = '')),
          (A = !1),
          s.removeEventListener('pointerdown', $),
          s.removeEventListener('pointermove', H),
          s.removeEventListener('pointerup', N),
          s.removeEventListener('pointercancel', R),
          s.removeEventListener('dragstart', U),
          s.removeEventListener('touchstart', W),
          s.removeEventListener('touchmove', X),
          s.removeEventListener('touchend', D),
          s.removeEventListener('touchcancel', D),
          n == null || n.removeEventListener('click', x),
          a == null || a.removeEventListener('click', x),
          window.removeEventListener('blur', z),
          document.removeEventListener('visibilitychange', B),
          clearTimeout(w),
          (this._galleryDragCleanup = null);
      });
  }
  disconnectedCallback() {
    var e, t, i, r;
    (this.connectedSwatchRequestToken = (this.connectedSwatchRequestToken || 0) + 1),
      (e = this.connectedSwatchAbortController) == null || e.abort(),
      (this.connectedSwatchAbortController = null),
      this.clearConnectedSwatchBusyState(),
      (this.connectionActive = !1),
      (this.connectionVersion = (this.connectionVersion || 0) + 1),
      this.galleryInitialised && document.removeEventListener('plp:view-changed', this.onPlpViewChange),
      (t = this._galleryDragCleanup) == null || t.call(this),
      (this._galleryDragCleanup = null),
      (i = this._sheetSwipeCleanup) == null || i.call(this),
      (this._sheetSwipeCleanup = null),
      this.finishGalleryAnimation(),
      clearTimeout(this._videoRestoreTimer),
      (r = Z()) == null || r.unobserve(this),
      this.closeSizeOverlay({immediate: !0, restoreFocus: !1}),
      this.unbindOverlayDismissListeners(),
      this.unmountMobileOverlay(),
      this.releaseBackgroundIsolation(),
      clearTimeout(this.overlayCloseTimer),
      clearTimeout(this.overlayFinishTimer),
      cancelAnimationFrame(this.overlayOpenFrame),
      cancelAnimationFrame(this.overlayVisibleFrame),
      cancelAnimationFrame(this.overlayFocusFrame),
      this.mobileMediaQuery &&
        this.onViewportChange &&
        (typeof this.mobileMediaQuery.removeEventListener == 'function'
          ? this.mobileMediaQuery.removeEventListener('change', this.onViewportChange)
          : this.mobileMediaQuery.removeListener(this.onViewportChange));
  }
  onPlpViewChange() {
    var e;
    this.isPlpToggleExcluded ||
      (this.applyGallerySlideOrder(),
      this.updateGalleryControls(),
      this.renderGallerySlide(0),
      this.updateGalleryProgress(),
      (e = this.gallery) == null || e.classList.toggle('card__gallery--item-view', this.cardImageView === 'item'));
  }
  stepGallery(e, t = 0) {
    var s;
    if (!((s = this.gallerySlides) != null && s.length)) return;
    this.finishGalleryAnimation();
    const i = this.gallerySlides.length,
      r = this.galleryIndex;
    (this.galleryIndex = (this.galleryIndex + e + i) % i),
      this.schedulePreloadGallerySlides(),
      this.slideGalleryAnimated(this.galleryIndex, e, t, r);
  }
  stepGalleryOrVideo(e, t = 0) {
    var s;
    if (this.showingVideo) {
      if (e > 0) {
        const n = this.takeGalleryVideoDragPreview('video-to-image', e);
        n ? this.slideGalleryVideoBoundary(n, !1) : this.revealGalleryFromVideo();
      }
      return;
    }
    const i = ((s = this.gallerySlides) == null ? void 0 : s.length) || 0;
    if (this.videoEl && ((e < 0 && this.galleryIndex === 0) || (e > 0 && this.galleryIndex === i - 1))) {
      const n = this.takeGalleryVideoDragPreview('image-to-video', e);
      n ? this.slideGalleryVideoBoundary(n, !0) : this.revealVideoFromGallery();
      return;
    }
    this.stepGallery(e, t);
  }
  takeGalleryVideoDragPreview(e, t) {
    const i = this._galleryDragPreview;
    return (i == null ? void 0 : i.kind) === e && i.direction === t
      ? ((this._galleryDragPreview = null), i)
      : (this.clearGalleryDragPreview(), null);
  }
  slideGalleryVideoBoundary(e, t) {
    var y;
    this.finishGalleryAnimation();
    const {incoming: i, outgoing: r, width: s} = e,
      n = (y = window.matchMedia) == null ? void 0 : y.call(window, '(prefers-reduced-motion: reduce)').matches,
      a = e.direction > 0 ? -s : s,
      c = t ? this.galleryIndex : e.index,
      l = {
        animationFrame: null,
        cancelled: !1,
        cleanup: null,
        cleanupTimer: null,
        decodeTimer: null,
        onTransitionEnd: null,
        started: !1,
      },
      o = (g) => {
        l.cancelled ||
          ((l.cancelled = !0),
          clearTimeout(l.cleanupTimer),
          clearTimeout(l.decodeTimer),
          cancelAnimationFrame(l.animationFrame),
          i.removeEventListener('transitionend', l.onTransitionEnd),
          (this.showingVideo = g ? t : !t),
          (this.galleryIndex = c),
          this.gallery.classList.toggle('card__gallery--video-hidden', this.showingVideo),
          this.videoEl.classList.toggle('card__video--hidden', !this.showingVideo),
          this.restoreGalleryDragPreview(e),
          this.updateGalleryProgress(),
          this._pendingGalleryAnimation === l && (this._pendingGalleryAnimation = null));
      },
      h = () => {
        if (!(l.cancelled || this._pendingGalleryAnimation !== l)) {
          if (
            (clearTimeout(l.decodeTimer),
            (l.decodeTimer = null),
            (l.started = !0),
            (this.showingVideo = t),
            (this.galleryIndex = c),
            this.updateGalleryProgress(),
            n)
          ) {
            o(!0);
            return;
          }
          i.addEventListener('transitionend', l.onTransitionEnd),
            (l.animationFrame = requestAnimationFrame(() => {
              if (this._pendingGalleryAnimation !== l) return;
              const g = `transform ${M}ms cubic-bezier(0.22, 1, 0.36, 1)`;
              (i.style.transition = g),
                (r.style.transition = g),
                (i.style.transform = 'translateX(0)'),
                (r.style.transform = `translateX(${a}px)`);
            })),
            (l.cleanupTimer = window.setTimeout(() => o(!0), M + 100));
        }
      };
    (l.cleanup = () => o(l.started)),
      (l.onTransitionEnd = (g) => {
        g.target !== i || g.propertyName !== 'transform' || o(!0);
      }),
      (this._pendingGalleryAnimation = l),
      e.ready || !e.decodePromise
        ? h()
        : ((l.decodeTimer = window.setTimeout(() => o(!1), Q)), e.decodePromise.then(h).catch(() => o(!1)));
  }
  revealGalleryFromVideo() {
    !this.videoEl ||
      !this.gallery ||
      ((this.showingVideo = !1),
      this.videoEl.classList.add('card__video--hidden'),
      this.gallery.classList.remove('card__gallery--video-hidden'),
      (this.galleryIndex = 0),
      this.renderGallerySlide(0),
      this.updateGalleryProgress());
  }
  revealVideoFromGallery() {
    !this.videoEl ||
      !this.gallery ||
      (this.cardImage && ((this.cardImage.style.transition = ''), (this.cardImage.style.transform = '')),
      (this.showingVideo = !0),
      this.gallery.classList.add('card__gallery--video-hidden'),
      this.videoEl.classList.remove('card__video--hidden'),
      this.updateGalleryProgress());
  }
  createGalleryImage(e, t) {
    const i = t.cloneNode(!1);
    return (
      i.removeAttribute('src'),
      i.removeAttribute('srcset'),
      i.removeAttribute('style'),
      i.classList.remove('gallery-slide-transition'),
      (i.draggable = !1),
      (i.loading = 'eager'),
      'fetchPriority' in i && (i.fetchPriority = 'high'),
      Y(i, e.model, e.clearcut, e.width, this.galleryRenderView, e.height, e.clearcutWidth, e.clearcutHeight),
      e.alt && (i.alt = e.alt),
      i
    );
  }
  getGalleryImageDecodePromise(e) {
    if (typeof e.decode == 'function')
      try {
        return Promise.resolve(e.decode());
      } catch (t) {
        return Promise.reject(t);
      }
    return e.complete && e.naturalWidth > 0
      ? Promise.resolve()
      : new Promise((t, i) => {
          const r = () => {
              e.removeEventListener('load', s), e.removeEventListener('error', n);
            },
            s = () => {
              r(), t();
            },
            n = () => {
              r(), i(new Error('Gallery image failed to load'));
            };
          e.addEventListener('load', s), e.addEventListener('error', n);
        });
  }
  getGalleryDragTarget(e) {
    var r;
    if (!((r = this.gallerySlides) != null && r.length)) return null;
    const t = this.gallerySlides.length;
    if (this.showingVideo) return e > 0 ? {index: 0, kind: 'video-to-image'} : null;
    if (this.videoEl && e < 0 && this.galleryIndex === 0) return {index: -1, kind: 'image-to-video'};
    if (this.videoEl && e > 0 && this.galleryIndex === t - 1) return {index: -1, kind: 'image-to-video'};
    const i = (this.galleryIndex + e + t) % t;
    return {index: i, kind: 'image', slide: this.gallerySlides[i]};
  }
  updateGalleryDragPreview(e, t) {
    var h, y;
    if (!this.cardImage) return;
    const i = this.getGalleryDragTarget(e);
    if (!i) {
      this.clearGalleryDragPreview();
      return;
    }
    const r = i.kind === 'video-to-image' ? this.videoEl : this.cardImage,
      s = this.cardImage.parentElement;
    if (!r || !s) return;
    const n =
        s.clientWidth ||
        ((h = this.querySelector('.card__media')) == null ? void 0 : h.clientWidth) ||
        this.cardImage.clientWidth ||
        r.clientWidth ||
        0,
      a = n || 1,
      c = n ? Math.max(-n, Math.min(n, t)) : t,
      l = (y = window.matchMedia) == null ? void 0 : y.call(window, '(prefers-reduced-motion: reduce)').matches;
    let o = this._galleryDragPreview;
    if (
      (o &&
        (o.direction !== e || o.index !== i.index || o.kind !== i.kind || o.outgoing !== r) &&
        (this.clearGalleryDragPreview(), (o = null)),
      !o && i.kind === 'image')
    ) {
      const g = this.createGalleryImage(i.slide, r),
        d = e > 0 ? a : -a;
      (g.style.transition = 'none'),
        (g.style.transform = `translateX(${d}px)`),
        s.appendChild(g),
        (o = {
          decodePromise: null,
          direction: e,
          incoming: g,
          index: i.index,
          kind: i.kind,
          latestOffset: c,
          outgoing: r,
          ready: !1,
          width: a,
        }),
        (this._galleryDragPreview = o),
        (o.decodePromise = this.getGalleryImageDecodePromise(g)),
        o.decodePromise.then(
          () => {
            (o.ready = !0), this._galleryDragPreview === o && !l && this.positionGalleryDragPreview(o);
          },
          () => {
            o.failed = !0;
          }
        );
    } else if (!o && i.kind === 'image-to-video') {
      const g = this.videoEl;
      clearTimeout(this._videoRestoreTimer),
        (g.style.opacity = '1'),
        (g.style.pointerEvents = 'none'),
        (g.style.transition = 'none'),
        (g.style.transform = `translateX(${-a}px)`),
        (o = {
          direction: e,
          incoming: g,
          index: i.index,
          kind: i.kind,
          latestOffset: c,
          outgoing: r,
          ready: !0,
          width: a,
        }),
        (this._galleryDragPreview = o);
    } else if (!o && i.kind === 'video-to-image') {
      const g = this.cardImage,
        d = g.parentElement;
      (d.style.opacity = '1'),
        (d.style.transition = 'none'),
        (d.style.visibility = 'visible'),
        (g.style.transition = 'none'),
        (g.style.transform = `translateX(${a}px)`),
        (o = {
          decodePromise: null,
          direction: e,
          incoming: g,
          incomingSurface: d,
          index: i.index,
          kind: i.kind,
          latestOffset: c,
          outgoing: r,
          ready: !1,
          width: a,
        }),
        (this._galleryDragPreview = o),
        (o.decodePromise = this.getGalleryImageDecodePromise(g)),
        o.decodePromise.then(
          () => {
            (o.ready = !0), this._galleryDragPreview === o && !l && this.positionGalleryDragPreview(o);
          },
          () => {
            o.failed = !0;
          }
        );
    }
    o
      ? ((o.latestOffset = c), o.ready && !l && this.positionGalleryDragPreview(o))
      : l || ((r.style.transition = 'none'), (r.style.transform = c ? `translateX(${c}px)` : ''));
  }
  positionGalleryDragPreview(e) {
    if (!e.outgoing.isConnected || !e.incoming.isConnected) return;
    const t = e.direction > 0 ? e.width : -e.width;
    (e.outgoing.style.transition = 'none'),
      (e.outgoing.style.transform = e.latestOffset ? `translateX(${e.latestOffset}px)` : ''),
      (e.incoming.style.transition = 'none'),
      (e.incoming.style.transform = `translateX(${t + e.latestOffset}px)`);
  }
  restoreGalleryDragPreview(e, {resetOutgoing: t = !0} = {}) {
    if (
      ((e.incoming.style.transition = ''),
      (e.incoming.style.transform = ''),
      e.kind === 'image'
        ? e.incoming.remove()
        : e.kind === 'image-to-video'
          ? ((e.incoming.style.opacity = ''), (e.incoming.style.pointerEvents = ''))
          : e.kind === 'video-to-image' &&
            ((e.incomingSurface.style.opacity = ''),
            (e.incomingSurface.style.transition = ''),
            (e.incomingSurface.style.visibility = '')),
      !t || !e.outgoing.isConnected)
    )
      return;
    const i = e.outgoing;
    if (!(e.kind === 'video-to-image' && i.classList.contains('card__video--hidden'))) {
      (i.style.transition = ''), (i.style.transform = '');
      return;
    }
    clearTimeout(this._videoRestoreTimer),
      (this._videoRestoreTimer = window.setTimeout(() => {
        i.classList.contains('card__video--hidden') && ((i.style.transition = ''), (i.style.transform = ''));
      }, ne + 50));
  }
  clearGalleryDragPreview({resetOutgoing: e = !0} = {}) {
    const t = this._galleryDragPreview;
    t && (this.restoreGalleryDragPreview(t, {resetOutgoing: e}), (this._galleryDragPreview = null));
  }
  takeGalleryDragPreview(e, t, i) {
    const r = this._galleryDragPreview;
    return (r == null ? void 0 : r.kind) === 'image' && r.index === e && r.direction === t && r.outgoing === i
      ? ((this._galleryDragPreview = null), r)
      : (this.clearGalleryDragPreview(), null);
  }
  slideGalleryAnimated(e, t, i = 0, r = this.galleryIndex) {
    var O, _, L;
    const s = (O = this.gallerySlides) == null ? void 0 : O[e];
    if (!s || !this.cardImage) return;
    const n = (_ = window.matchMedia) == null ? void 0 : _.call(window, '(prefers-reduced-motion: reduce)').matches,
      a = this.cardImage.parentElement;
    if (!a) {
      this.clearGalleryDragPreview(),
        (this.cardImage.style.transition = ''),
        (this.cardImage.style.transform = ''),
        this.renderGallerySlide(e),
        this.updateGalleryProgress();
      return;
    }
    this.finishGalleryAnimation();
    const c =
        a.clientWidth ||
        ((L = this.querySelector('.card__media')) == null ? void 0 : L.clientWidth) ||
        this.cardImage.clientWidth ||
        0,
      l = c || 1,
      o = c ? Math.max(-c, Math.min(c, i)) : i,
      h = this.cardImage,
      y = this.takeGalleryDragPreview(e, t, h);
    h.classList.remove('gallery-slide-transition'), (h.style.transition = 'none');
    const g = y != null && y.ready ? o : 0;
    h.style.transform = g ? `translateX(${g}px)` : '';
    const d = (y == null ? void 0 : y.incoming) || this.createGalleryImage(s, h),
      w = t > 0 ? l : -l,
      I = t > 0 ? -l : l,
      m = {
        animationFrame: null,
        cancelled: !1,
        cleanup: null,
        cleanupTimer: null,
        decodeTimer: null,
        newImg: d,
        onError: null,
        onLoad: null,
        onRecoveryTransitionEnd: null,
        onTransitionEnd: null,
        previousIndex: r,
        started: !1,
        visibleLiveOffsetPx: g,
      },
      b = () => {
        (m.cancelled = !0),
          clearTimeout(m.cleanupTimer),
          clearTimeout(m.decodeTimer),
          cancelAnimationFrame(m.animationFrame),
          d.removeEventListener('transitionend', m.onTransitionEnd),
          m.onRecoveryTransitionEnd && h.removeEventListener('transitionend', m.onRecoveryTransitionEnd),
          m.onLoad && d.removeEventListener('load', m.onLoad),
          m.onError && d.removeEventListener('error', m.onError),
          m.started
            ? (h.remove(),
              d.classList.remove('gallery-slide-transition'),
              (d.style.transform = ''),
              (this.cardImage = d))
            : (d.remove(),
              (this.cardImage = h),
              (h.style.transition = ''),
              (h.style.transform = ''),
              this._pendingGalleryAnimation === m &&
                ((this.galleryIndex = m.previousIndex), this.updateGalleryProgress())),
          this._pendingGalleryAnimation === m && (this._pendingGalleryAnimation = null);
      },
      C = (z) => {
        z.target !== d || z.propertyName !== 'transform' || b();
      };
    (m.cleanup = b), (m.onTransitionEnd = C), (this._pendingGalleryAnimation = m);
    const P = () => {
        if (!(m.cancelled || m.started || this._pendingGalleryAnimation !== m)) {
          if (!m.visibleLiveOffsetPx) {
            b();
            return;
          }
          (m.cancelled = !0),
            clearTimeout(m.decodeTimer),
            (m.decodeTimer = null),
            (h.style.transition = `transform ${G}ms ease`),
            (h.style.transform = ''),
            d.isConnected &&
              ((d.style.transition = `transform ${G}ms ease`), (d.style.transform = `translateX(${w}px)`)),
            (m.onRecoveryTransitionEnd = (z) => {
              z.target !== h || z.propertyName !== 'transform' || b();
            }),
            h.addEventListener('transitionend', m.onRecoveryTransitionEnd),
            (m.cleanupTimer = window.setTimeout(b, G + 100));
        }
      },
      T = () => {
        if (!(m.cancelled || this._pendingGalleryAnimation !== m)) {
          if (
            (clearTimeout(m.decodeTimer),
            (m.decodeTimer = null),
            (m.started = !0),
            (h.style.transition = 'none'),
            (h.style.transform = o ? `translateX(${o}px)` : ''),
            (d.style.transition = 'none'),
            (d.style.transform = `translateX(${w + o}px)`),
            d.isConnected || a.appendChild(d),
            (this.cardImage = d),
            this.updateGalleryProgress(),
            n)
          ) {
            b();
            return;
          }
          d.addEventListener('transitionend', C),
            (m.animationFrame = requestAnimationFrame(() => {
              this._pendingGalleryAnimation === m &&
                (h.classList.add('gallery-slide-transition'),
                d.classList.add('gallery-slide-transition'),
                (h.style.transition = ''),
                (d.style.transition = ''),
                (h.style.transform = `translateX(${I}px)`),
                (d.style.transform = 'translateX(0)'));
            })),
            (m.cleanupTimer = window.setTimeout(b, M + 100));
        }
      };
    (m.decodeTimer = window.setTimeout(P, Q)),
      y != null && y.decodePromise
        ? y.decodePromise.then(T).catch(P)
        : typeof d.decode == 'function'
          ? d.decode().then(T).catch(P)
          : d.complete && d.naturalWidth > 0
            ? T()
            : ((m.onLoad = T),
              (m.onError = P),
              d.addEventListener('load', m.onLoad, {once: !0}),
              d.addEventListener('error', m.onError, {once: !0}));
  }
  finishGalleryAnimation() {
    const e = this._pendingGalleryAnimation;
    e && e.cleanup();
  }
  renderGallerySlide(e) {
    var i;
    const t = (i = this.gallerySlides) == null ? void 0 : i[e];
    !t ||
      !this.cardImage ||
      (this.clearGalleryDragPreview(),
      this.finishGalleryAnimation(),
      Y(
        this.cardImage,
        t.model,
        t.clearcut,
        t.width,
        this.galleryRenderView,
        t.height,
        t.clearcutWidth,
        t.clearcutHeight
      ),
      t.alt && (this.cardImage.alt = t.alt));
  }
  updateGalleryProgress() {
    if (!this.galleryProgress) return;
    const e = this.showingVideo ? 0 : this.galleryIndex + (this.videoEl ? 1 : 0);
    this.galleryProgress.style.setProperty('--gallery-index', String(e));
  }
  setGalleryForColor(e) {
    var r;
    this.finishGalleryAnimation();
    const t = ((r = this.gallerySlidesByColor) == null ? void 0 : r[k(e)]) || [];
    if (!t.length) {
      (this.canonicalGallerySlides = []),
        (this.gallerySlides = []),
        (this.galleryIndex = 0),
        this.updateGalleryControls(),
        this.configureGalleryInteractions();
      return;
    }
    const i = t[t.length - 1].model;
    (this.canonicalGallerySlides = t.map((s) => ({...s, clearcut: s.clearcut || i}))),
      this.applyGallerySlideOrder(),
      this.schedulePreloadGallerySlides(),
      this.updateGalleryControls(),
      this.configureGalleryInteractions(),
      this.renderGallerySlide(0);
  }
  applyGallerySlideOrder() {
    const e = this.canonicalGallerySlides || [],
      t = e.findIndex((i) => i.model === i.clearcut);
    if (((this.itemSlideIndex = t), this.cardImageView !== 'item')) this.gallerySlides = e;
    else if (t >= 0) this.gallerySlides = t > 0 ? [...e.slice(t), ...e.slice(0, t)] : e;
    else {
      const i = this.buildGhostSlide(e);
      this.gallerySlides = i ? [i, ...e] : e;
    }
    this.galleryIndex = 0;
  }
  buildGhostSlide(e) {
    const t = e[0],
      i = t == null ? void 0 : t.clearcut;
    return i
      ? {
          model: i,
          clearcut: i,
          width: t.clearcutWidth || t.width,
          height: t.clearcutHeight || t.height,
          clearcutWidth: t.clearcutWidth,
          clearcutHeight: t.clearcutHeight,
          alt: t.alt,
        }
      : null;
  }
  schedulePreloadGallerySlides() {
    var t;
    if (!this.isConnected || !((t = this.gallerySlides) != null && t.length)) return;
    const e = Z();
    if (!e) {
      le(() => this.preloadGallerySlides());
      return;
    }
    e.observe(this);
  }
  preloadGallerySlides() {
    const e = this.gallerySlides || [],
      t = e.length;
    if (!t) return;
    const i = (this.galleryIndex + 1) % t,
      r = (this.galleryIndex - 1 + t) % t,
      s = this.showingVideo ? [0] : t > 1 ? [i, r] : [];
    [...new Set(s)].forEach((n) => {
      const a = e[n];
      a && (j(a.model, a.width), a.clearcut && a.clearcut !== a.model && j(a.clearcut, a.clearcutWidth));
    });
  }
  updateGalleryControls() {
    if (!this.gallery) return;
    const e = this.getGalleryStepCount();
    this.gallery.classList.toggle('card__gallery--multiple', e > 1);
    const t = this.gallery.querySelector(f.galleryProgress);
    if (!t) return;
    (this.galleryProgress = t),
      t.style.setProperty('--gallery-count', String(e)),
      t.style.setProperty('--gallery-index', String(this.galleryIndex));
    const i = t.querySelector(f.galleryProgressTrack);
    if (i) {
      i.innerHTML = '';
      for (let r = 0; r < e; r++) {
        const s = document.createElement('span');
        (s.className = 'card__gallery-progress-segment'), i.appendChild(s);
      }
    }
  }
  getGalleryStepCount() {
    var e;
    return (((e = this.gallerySlides) == null ? void 0 : e.length) || 0) + (this.videoEl ? 1 : 0);
  }
  initSwatches() {
    this.swatchesInitialised ||
      ((this.swatches = this.querySelector(f.swatches)),
      this.swatches &&
        ((this.swatchesInitialised = !0),
        (this.onSwatchClick = this.onSwatchClick.bind(this)),
        (this.onSwatchChange = this.onSwatchChange.bind(this)),
        this.swatches.addEventListener('click', this.onSwatchClick),
        this.swatches.addEventListener('change', this.onSwatchChange)));
  }
  clearConnectedSwatchBusyState() {
    this.removeAttribute('aria-busy');
  }
  getConnectedSwatchSelectionSnapshot() {
    var e, t;
    return {
      activeOptionValueId: this.getActiveConnectedSwatchId(),
      checkedOptionValueId:
        ((t =
          (e = this.swatches) == null
            ? void 0
            : e.querySelector('input[type="radio"]:checked[data-option-value-id]')) == null
          ? void 0
          : t.dataset.optionValueId) || '',
    };
  }
  cancelConnectedProductRequest() {
    var e;
    (this.connectedSwatchRequestToken = (this.connectedSwatchRequestToken || 0) + 1),
      (e = this.connectedSwatchAbortController) == null || e.abort(),
      (this.connectedSwatchAbortController = null),
      (this.connectedSwatchNavigationPending = null),
      this.clearConnectedSwatchBusyState();
  }
  onSwatchClick(e) {
    const t = e.target.closest('.product-swatches label');
    if (!t) return;
    const i = this.getConnectedSwatch(t);
    if (i) {
      this.handleConnectedSwatch(e, t, i);
      return;
    }
    e.preventDefault(),
      this.setActiveSwatch(t),
      this.updateCardImageFromSwatch(t),
      this.isSizeOverlayOpen() &&
        (clearTimeout(this.overlayCloseTimer),
        (this.overlayCloseTimer = null),
        this.renderSizeGrid(),
        this.populateSheetSwatches());
  }
  onSwatchChange(e) {
    if (!(e.target instanceof HTMLInputElement)) return;
    const t = e.target.closest('.product-swatches label');
    if (!t) return;
    const i = this.getConnectedSwatch(t);
    i && this.handleConnectedSwatch(e, t, i);
  }
  getConnectedSwatch(e) {
    const t = e.querySelector('input[type="radio"]'),
      i =
        e.hasAttribute('data-combined-listing-option') ||
        (t == null ? void 0 : t.hasAttribute('data-combined-listing-option')),
      r = e.dataset.productUrl || (t == null ? void 0 : t.dataset.productUrl);
    if (!i && !r) return null;
    const s = r || this.dataset.canonicalProductUrl || this.dataset.productUrl;
    return s
      ? {productUrl: s, optionValueId: e.dataset.optionValueId || (t == null ? void 0 : t.dataset.optionValueId) || ''}
      : null;
  }
  getConnectedSwatchDestination(e, t) {
    const i = new URL(e, window.location.href);
    return t && (i.searchParams.delete('variant'), i.searchParams.set('option_values', t)), i;
  }
  get isConnectedCardAjaxEnabled() {
    return this.hasAttribute('data-combined-listing-card-section');
  }
  getConnectedProductKey(e) {
    var r;
    const t = new URL(e, window.location.href),
      i = (r = t.pathname.match(/\/products\/[^/]+/i)) == null ? void 0 : r[0];
    return `${t.origin}${i || t.pathname.replace(/\/$/, '') || '/'}`;
  }
  isCurrentConnectedSwatch(e, t) {
    return e.classList.contains(v.swatchActive)
      ? !0
      : this.dataset.productUrl
        ? this.getConnectedProductKey(t.href) === this.getConnectedProductKey(this.dataset.productUrl)
        : !1;
  }
  handleConnectedSwatch(e, t, i) {
    const r = this.getConnectedSwatchDestination(i.productUrl, i.optionValueId);
    if ((e.preventDefault(), e.stopPropagation(), this.isCurrentConnectedSwatch(t, r))) {
      this.cancelConnectedProductRequest(), this.restoreConnectedSwatchSelection();
      return;
    }
    if (e instanceof MouseEvent && (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey)) {
      e.altKey || this.openConnectedProduct(r.href);
      return;
    }
    this.isConnectedCardAjaxEnabled
      ? this.renderConnectedProduct(r, i.optionValueId)
      : this.navigateToConnectedProduct(r.href);
  }
  getConnectedCardRequestUrl(e, t) {
    const i = new URL(e.href);
    return (
      i.searchParams.delete('variant'),
      t && i.searchParams.set('option_values', t),
      i.searchParams.set('section_id', this.dataset.combinedListingCardSection || ae),
      i
    );
  }
  openConnectedProduct(e) {
    window.open(e, '_blank', 'noopener');
  }
  navigateToConnectedProduct(e) {
    window.location.assign(e);
  }
  async renderConnectedProduct(e, t) {
    var a;
    const i = this.getConnectedCardRequestUrl(e, t),
      r = this.getConnectedSwatchSelectionSnapshot();
    (a = this.connectedSwatchAbortController) == null || a.abort(),
      (this.connectedSwatchAbortController = new AbortController());
    const s = this.connectedSwatchAbortController,
      n = (this.connectedSwatchRequestToken || 0) + 1;
    (this.connectedSwatchRequestToken = n), this.setAttribute('aria-busy', 'true');
    try {
      const c = await fetch(i, {signal: s.signal});
      if (!c.ok) throw new Error(`Combined Listings card request failed with ${c.status}`);
      const l = await c.text();
      if (n !== this.connectedSwatchRequestToken || !this.isConnected) return;
      const h = new DOMParser().parseFromString(l, 'text/html').querySelector('[data-combined-listing-card-response]');
      if (!h) throw new Error('Combined Listings card response is missing its response root');
      const y = this.parseConnectedProductResponse(h, e, t);
      this.applyConnectedProductResponse(y),
        (this.connectedSwatchAbortController = null),
        this.clearConnectedSwatchBusyState(),
        this.focusConnectedSwatch(t);
    } catch (c) {
      if (n !== this.connectedSwatchRequestToken || c.name === 'AbortError') return;
      (this.connectedSwatchAbortController = null),
        this.clearConnectedSwatchBusyState(),
        this.restoreConnectedSwatchSelection(r.activeOptionValueId || r.checkedOptionValueId),
        window.console.error(c);
    }
  }
  parseConnectedProductResponse(e, t, i) {
    var g;
    const r = e.dataset.productUrl || `${t.pathname}${t.search}`,
      s = new URL(r, window.location.href),
      n = e.querySelector('[data-combined-listing-card-gallery-json]'),
      a = e.querySelector('[data-combined-listing-card-swatches] .product-swatches'),
      c = e.querySelector('[data-combined-listing-card-price]');
    if (!n || !a || !c) throw new Error('Combined Listings card response is incomplete');
    let l;
    try {
      l = JSON.parse(n.textContent);
    } catch {
      throw new Error('Combined Listings card response has invalid gallery data');
    }
    const o = Number(this.dataset.combinedListingCardGalleryLimit);
    Number.isInteger(o) &&
      o > 0 &&
      Object.keys((l == null ? void 0 : l.slidesByColor) || {}).forEach((d) => {
        const w = l.slidesByColor[d];
        Array.isArray(w) && (l.slidesByColor[d] = w.slice(0, o));
      });
    const h = (g = l == null ? void 0 : l.slidesByColor) == null ? void 0 : g[l.defaultColor];
    if (!(l != null && l.defaultColor) || !Array.isArray(h) || !h.length)
      throw new Error('Combined Listings card response has no default gallery slides');
    if (!Array.from(a.querySelectorAll('input[data-option-value-id]')).find((d) => d.dataset.optionValueId === i))
      throw new Error('Combined Listings card response is missing the selected swatch');
    return {
      responseRoot: e,
      canonicalUrl: s,
      optionValueId: i,
      galleryData: l,
      galleryJson: n.textContent,
      responseSwatches: a,
      selectedVariantId: e.dataset.selectedVariantId || '',
      productTitle: e.dataset.productTitle || '',
      productLinkLabel: e.dataset.productLinkLabel || e.dataset.productTitle || '',
      productId: e.dataset.productId || '',
    };
  }
  applyConnectedProductResponse(e) {
    const {
      responseRoot: t,
      canonicalUrl: i,
      optionValueId: r,
      galleryData: s,
      galleryJson: n,
      responseSwatches: a,
      selectedVariantId: c,
      productTitle: l,
      productLinkLabel: o,
      productId: h,
    } = e;
    (this.dataset.canonicalProductUrl = `${i.pathname}${i.search}${i.hash}`),
      (this.dataset.productUrl = this.getCollectionScopedProductUrl(i)),
      h && (this.dataset.productId = h),
      t.dataset.productType != null && (this.dataset.productType = t.dataset.productType),
      t.dataset.productAvailable != null && (this.dataset.productAvailable = t.dataset.productAvailable),
      this.updateConnectedProductContent(t, l, o, h, c),
      this.updateConnectedProductGallery(s, n),
      this.updateConnectedProductSwatches(a, r),
      this.updateConnectedProductLinks(i, c);
  }
  getCollectionScopedProductUrl(e) {
    var n, a;
    const i =
        (n = new URL(this.dataset.productUrl || e.href, window.location.href).pathname.match(
          /^(.*\/collections\/[^/]+)\/products\/[^/]+/i
        )) == null
          ? void 0
          : n[1],
      r = (a = e.pathname.match(/\/products\/[^/]+/i)) == null ? void 0 : a[0];
    return `${i && r ? `${i}${r}` : e.pathname}${e.search}${e.hash}`;
  }
  updateConnectedProductLinks(e, t) {
    this.querySelectorAll('a[href]').forEach((i) => {
      var a, c;
      if (i.closest('.product-swatches') && !i.classList.contains('product-swatches__more-link')) return;
      const r = new URL(i.href, window.location.href),
        s = (a = r.pathname.match(/^(.*\/collections\/[^/]+)\/products\/[^/]+/i)) == null ? void 0 : a[1],
        n = (c = e.pathname.match(/\/products\/[^/]+/i)) == null ? void 0 : c[0];
      (r.pathname = s && n ? `${s}${n}` : e.pathname),
        (r.hash = e.hash),
        r.searchParams.delete('option_values'),
        r.searchParams.delete('section_id'),
        t ? r.searchParams.set('variant', t) : r.searchParams.delete('variant'),
        (i.href = `${r.pathname}${r.search}${r.hash}`);
    });
  }
  updateConnectedProductContent(e, t, i, r, s) {
    var a;
    t &&
      (this.querySelectorAll('.card__heading a').forEach((c) => {
        c.textContent = t;
      }),
      this.querySelectorAll('.card__gallery-link, .card__video a').forEach((c) => {
        c.setAttribute('aria-label', i || t);
      }));
    const n = (a = this.form) == null ? void 0 : a.querySelector('input[type="hidden"][name="id"]');
    n && (n.value = s),
      r &&
        this.querySelectorAll('rivo-favorite-button[data-product-id]').forEach((c) => {
          c.dataset.productId = r;
        }),
      this.replaceConnectedContent(e, '[data-combined-listing-card-price]', '[data-combined-listing-card-price]'),
      this.replaceConnectedContent(e, '[data-combined-listing-card-badge]', '.card__badge', !0, !1),
      this.replaceConnectedContent(
        e,
        '[data-combined-listing-card-quick-add]',
        '[data-combined-listing-card-quick-add]',
        !0
      );
  }
  replaceConnectedContent(e, t, i, r = !1, s = !0) {
    const n = e.querySelector(t);
    if (!n) return;
    (r ? this.querySelectorAll(i) : [this.querySelector(i)]).forEach((c) => {
      if (c)
        if (s) {
          const l = n.cloneNode(!0);
          c.replaceWith(l);
        } else c.innerHTML = n.innerHTML;
    });
  }
  updateConnectedProductGallery(e, t) {
    var r, s;
    if (!this.gallery || !this.cardImage) return;
    (this.galleryData = e),
      (this.gallerySlidesByColor = {}),
      Object.entries(this.galleryData.slidesByColor || {}).forEach(([n, a]) => {
        this.gallerySlidesByColor[k(n)] = a;
      });
    const i = this.gallery.querySelector(f.galleryJson);
    i && (i.textContent = t),
      (r = this.videoEl) == null || r.remove(),
      (this.videoEl = null),
      (this.showingVideo = !1),
      this.gallery.classList.remove('card__gallery--video-hidden'),
      (s = this.gallery.closest('.card__media')) == null || s.removeAttribute('data-has-video'),
      this.setGalleryForColor(this.galleryData.defaultColor),
      this.updateGalleryProgress();
  }
  updateConnectedProductSwatches(e, t) {
    if (!this.swatches) return;
    this.swatches.replaceChildren(...Array.from(e.children, (s) => s.cloneNode(!0)));
    const i = this.findConnectedSwatchControl(t),
      r = i == null ? void 0 : i.closest('label');
    i instanceof HTMLInputElement && (i.checked = !0),
      r &&
        this.swatches.querySelectorAll(`label.${v.swatchActive}`).forEach((s) => {
          s.classList.toggle(v.swatchActive, s === r);
        });
  }
  findConnectedSwatchControl(e) {
    var t;
    return (
      Array.from(((t = this.swatches) == null ? void 0 : t.querySelectorAll('[data-option-value-id]')) || []).find(
        (i) => i.dataset.optionValueId === e && i instanceof HTMLInputElement
      ) || null
    );
  }
  getActiveConnectedSwatchId() {
    var e, t;
    return (
      ((t = (e = this.swatches) == null ? void 0 : e.querySelector(`label.${v.swatchActive} [data-option-value-id]`)) ==
      null
        ? void 0
        : t.dataset.optionValueId) || ''
    );
  }
  restoreConnectedSwatchSelection(e = this.getActiveConnectedSwatchId()) {
    const t = this.findConnectedSwatchControl(e),
      i = t == null ? void 0 : t.closest('label');
    !t ||
      !i ||
      ((t.checked = !0),
      this.swatches.querySelectorAll(`label.${v.swatchActive}`).forEach((r) => {
        r.classList.toggle(v.swatchActive, r === i);
      }));
  }
  focusConnectedSwatch(e) {
    const t = this.findConnectedSwatchControl(e);
    if (t)
      try {
        t.focus({preventScroll: !0});
      } catch {
        t.focus();
      }
  }
  setActiveSwatch(e) {
    this.swatches.querySelectorAll(`label.${v.swatchActive}`).forEach((i) => {
      i.classList.remove(v.swatchActive);
    }),
      e.classList.add(v.swatchActive);
    const t = e.querySelector('input[type="radio"]');
    t && (t.checked = !0);
  }
  updateCardImageFromSwatch(e) {
    if (!this.cardImage) return;
    const t = e.querySelector('input[type="radio"]'),
      i = t == null ? void 0 : t.value;
    i && (this.showingVideo && this.revealGalleryFromVideo(), this.setGalleryForColor(i));
  }
  initSizeOverlay() {
    var t, i, r, s;
    if (
      this.sizeOverlayInitialised ||
      ((this.sizeOverlayTrigger = this.querySelector(f.sizeOverlayTrigger)), !this.sizeOverlayTrigger)
    )
      return;
    (this.sizeOverlay = this.querySelector(f.sizeOverlay)),
      (this.sizeBackdrop = this.querySelector(f.sizeBackdrop)),
      (this.sizeGrid = this.querySelector(f.sizeGrid)),
      (this.sizeSheetHeader = this.querySelector(f.sizeSheetHeader)),
      (this.sizeSheetSwatches = this.querySelector(f.sizeSheetSwatches)),
      (this.overlayActive = !1),
      (this.mobileOverlayMounted = !1);
    const e = this.querySelector('[data-product-json]');
    if (e) {
      try {
        this.productJson = JSON.parse(e.textContent);
      } catch {
        return;
      }
      if (
        ((this.sizeOverlayInitialised = !0),
        (this.sizeOptionIndex = Number(this.dataset.sizeOptionIndex)),
        (this.colorOptionName = this.dataset.colorOptionName || ''),
        (this.hasSizeOption = Number.isInteger(this.sizeOptionIndex) && this.sizeOptionIndex >= 0),
        this.sizeOverlay)
      ) {
        (this.sizeOverlayParent = this.sizeOverlay.parentElement),
          this.sizeOverlay.setAttribute('role', 'dialog'),
          this.sizeOverlay.removeAttribute('aria-modal'),
          this.sizeOverlay.setAttribute('tabindex', '-1');
        const a =
          ((i = (t = this.sizeOverlay.querySelector('.card__size-sheet-title')) == null ? void 0 : t.textContent) ==
          null
            ? void 0
            : i.trim()) || this.sizeOverlayTrigger.getAttribute('aria-label');
        a && this.sizeOverlay.setAttribute('aria-label', a);
      }
      this.sizeBackdrop && (this.sizeBackdropParent = this.sizeBackdrop.parentElement),
        (this.onSizeOverlayTriggerClick = this.onSizeOverlayTriggerClick.bind(this)),
        (this.onDocumentClick = this.onDocumentClick.bind(this)),
        (this.onKeydown = this.onKeydown.bind(this)),
        (this.onViewportChange = this.onViewportChange.bind(this)),
        (this.mobileMediaQuery = window.matchMedia(`(max-width: ${J - 1}px)`)),
        ((r = this.sizeGrid) == null ? void 0 : r.getAttribute('role')) === 'list' &&
          this.sizeGrid.removeAttribute('role'),
        this.sizeOverlayTrigger.addEventListener('click', this.onSizeOverlayTriggerClick),
        this.querySelectorAll(f.sizeOverlayClose).forEach((n) => {
          n.addEventListener('click', (a) => {
            a.preventDefault(), a.stopPropagation(), this.closeSizeOverlay();
          });
        }),
        (s = this.sizeBackdrop) == null || s.addEventListener('click', () => this.closeSizeOverlay());
    }
  }
  initSheetSwipeToDismiss() {
    if (this._sheetSwipeCleanup || !this.sizeSheetHeader || !this.sizeOverlay) return;
    const e = 80,
      t = 0.5;
    let i = 0,
      r = 0,
      s = null,
      n = !1;
    const a = () => {
        (this.sizeOverlay.style.transition = ''), (this.sizeOverlay.style.transform = '');
      },
      c = (y) => {
        var g, d;
        y.isPrimary === !1 ||
          (Number.isFinite(y.button) && y.button !== 0) ||
          y.target.closest('[data-size-overlay-close]') ||
          (s === null &&
            ((s = y.pointerId),
            (i = y.clientY),
            (r = y.timeStamp),
            (n = !1),
            (d = (g = this.sizeSheetHeader).setPointerCapture) == null || d.call(g, y.pointerId)));
      },
      l = (y) => {
        if (y.pointerId !== s) return;
        const g = y.clientY - i;
        g <= 0 ||
          ((n = !0),
          (this.sizeOverlay.style.transition = 'none'),
          (this.sizeOverlay.style.transform = `translateY(${g}px)`));
      },
      o = (y) => {
        if (y.pointerId !== s) return;
        s = null;
        const g = y.clientY - i,
          d = y.timeStamp - r,
          w = d > 0 ? g / d : 0;
        a(), n && g > 0 && (g > e || w > t) && this.closeSizeOverlay(), (n = !1);
      },
      h = (y) => {
        y.pointerId === s && ((s = null), (n = !1), a());
      };
    this.sizeSheetHeader.addEventListener('pointerdown', c),
      this.sizeSheetHeader.addEventListener('pointermove', l),
      this.sizeSheetHeader.addEventListener('pointerup', o),
      this.sizeSheetHeader.addEventListener('pointercancel', h),
      (this._sheetSwipeCleanup = () => {
        if (s !== null)
          try {
            this.sizeSheetHeader.releasePointerCapture(s);
          } catch {}
        (s = null),
          (n = !1),
          a(),
          this.sizeSheetHeader.removeEventListener('pointerdown', c),
          this.sizeSheetHeader.removeEventListener('pointermove', l),
          this.sizeSheetHeader.removeEventListener('pointerup', o),
          this.sizeSheetHeader.removeEventListener('pointercancel', h),
          (this._sheetSwipeCleanup = null);
      });
  }
  getSelectedColor() {
    var i, r;
    if (!this.colorOptionName) return '';
    const e = this.form.querySelector(f.formInput(`options[${this.colorOptionName}]`) + ':checked');
    if (e != null && e.value) return e.value;
    const t = (i = this.swatches) == null ? void 0 : i.querySelector('input[type="radio"]:checked');
    return (t == null ? void 0 : t.value) || ((r = this.galleryData) == null ? void 0 : r.defaultColor) || '';
  }
  getVariantsForSelectedColor() {
    const e = k(this.getSelectedColor());
    return this.productJson.variants.filter((t) => (e ? k(t.options[0]) === e : !0));
  }
  getSizeValuesForSelectedColor() {
    if (!this.hasSizeOption) return [];
    const e = new Set();
    return (
      this.getVariantsForSelectedColor().forEach((t) => {
        const i = t.options[this.sizeOptionIndex];
        i && e.add(i);
      }),
      Array.from(e)
    );
  }
  getVariantForSize(e) {
    return this.getVariantsForSelectedColor().find((t) => t.options[this.sizeOptionIndex] === e);
  }
  getVariantUrl(e) {
    const t = this.dataset.productUrl || `/products/${this.productJson.handle || ''}`,
      i = new URL(t, window.location.origin);
    return e != null && e.id && i.searchParams.set('variant', String(e.id)), `${i.pathname}${i.search}${i.hash}`;
  }
  renderSizeGrid() {
    if (!this.sizeGrid) return;
    const e = this.getSizeValuesForSelectedColor();
    (this.sizeGrid.innerHTML = ''),
      e.length &&
        e.forEach((t) => {
          var n;
          const i = this.getVariantForSize(t),
            r = document.createElement('a');
          (r.className = 'card__size-option button'), (r.dataset.sizeOption = ''), (r.href = this.getVariantUrl(i));
          const s = document.createElement('span');
          if (
            ((s.className = 'card__size-option-label'),
            (s.textContent = t),
            r.appendChild(s),
            !(i != null && i.available))
          )
            r.classList.add(v.sizeOptionDisabled),
              r.setAttribute('aria-label', `${t} — ${window.variantStrings.soldOut}`);
          else if ((n = i.custom) != null && n.is_low_stock) {
            r.classList.add(v.sizeOptionLowStock);
            const a = document.createElement('span');
            (a.className = 'card__size-option-stock'),
              (a.textContent = `${i.inventory_quantity} left!`),
              r.appendChild(a);
          }
          i != null && i.id && (r.dataset.variantId = String(i.id)), this.sizeGrid.appendChild(r);
        });
  }
  populateSheetSwatches() {
    if (!this.sizeSheetSwatches || ((this.sizeSheetSwatches.innerHTML = ''), !this.colorOptionName || !this.swatches))
      return;
    const e = document.createElement('ul');
    (e.className = 'product-swatches small card__size-sheet-swatches-list'),
      this.swatches.querySelectorAll('li').forEach((t) => {
        const i = t.querySelector('label');
        if (!i) {
          e.appendChild(t.cloneNode(!0));
          return;
        }
        const r = document.createElement('li'),
          s = i.cloneNode(!0);
        s.querySelectorAll('input').forEach((n) => {
          n.removeAttribute('name');
        }),
          r.appendChild(s),
          e.appendChild(r),
          s.addEventListener('click', (n) => {
            n.preventDefault(), n.stopPropagation();
            const a = this.getConnectedSwatch(i);
            if (a) {
              this.handleConnectedSwatch(n, i, a);
              return;
            }
            const c = i.querySelector('input[type="radio"]');
            c && ((c.checked = !0), c.dispatchEvent(new Event('change', {bubbles: !0}))),
              this.setActiveSwatch(i),
              this.updateCardImageFromSwatch(i),
              this.renderSizeGrid(),
              this.populateSheetSwatches();
          });
      }),
      this.sizeSheetSwatches.appendChild(e);
  }
  onSizeOverlayTriggerClick(e) {
    if ((e.preventDefault(), e.stopPropagation(), this.isSizeOverlayOpen())) {
      this.closeSizeOverlay();
      return;
    }
    this.openSizeOverlay();
  }
  bindOverlayDismissListeners() {
    this.overlayDismissBound ||
      (document.addEventListener('click', this.onDocumentClick),
      document.addEventListener('keydown', this.onKeydown),
      (this.overlayDismissBound = !0));
  }
  unbindOverlayDismissListeners() {
    this.overlayDismissBound &&
      (document.removeEventListener('click', this.onDocumentClick),
      document.removeEventListener('keydown', this.onKeydown),
      (this.overlayDismissBound = !1));
  }
  openSizeOverlay() {
    var t, i, r;
    if (!this.sizeOverlay || this.overlayActive) return;
    document.querySelectorAll('product-card').forEach((s) => {
      var n;
      s !== this &&
        (n = s.isSizeOverlayOpen) != null &&
        n.call(s) &&
        s.closeSizeOverlay({immediate: !0, restoreFocus: !1});
    }),
      (this.overlayActive = !0),
      (this.overlayReturnFocus =
        document.activeElement instanceof HTMLElement && document.activeElement !== document.body
          ? document.activeElement
          : this.sizeOverlayTrigger),
      clearTimeout(this.overlayFinishTimer),
      cancelAnimationFrame(this.overlayOpenFrame),
      cancelAnimationFrame(this.overlayVisibleFrame),
      cancelAnimationFrame(this.overlayFocusFrame),
      this.overlayTransitionHandler &&
        (this.sizeOverlay.removeEventListener('transitionend', this.overlayTransitionHandler),
        (this.overlayTransitionHandler = null));
    const e = this.isMobileViewport();
    e ? this.sizeOverlay.setAttribute('aria-modal', 'true') : this.sizeOverlay.removeAttribute('aria-modal'),
      e || (this.sizeOverlayTrigger.hidden = !0),
      this.bindOverlayDismissListeners(),
      this.renderSizeGrid(),
      e
        ? (this.populateSheetSwatches(),
          (t = this.sizeSheetHeader) == null || t.removeAttribute('hidden'),
          this.mountMobileOverlay(),
          this.isolateBackground())
        : (i = this.sizeSheetHeader) == null || i.setAttribute('hidden', ''),
      this.sizeOverlay.removeAttribute('hidden'),
      e && ((r = this.sizeBackdrop) == null || r.removeAttribute('hidden')),
      this.classList.add(v.cardSizeOverlayOpen),
      this.sizeOverlayTrigger.setAttribute('aria-expanded', 'true'),
      (this.overlayOpenFrame = requestAnimationFrame(() => {
        this.overlayVisibleFrame = requestAnimationFrame(() => {
          var s;
          this.overlayActive &&
            (this.sizeOverlay.classList.add(v.overlayOpen),
            e && ((s = this.sizeBackdrop) == null || s.classList.add(v.backdropOpen)),
            (this.overlayFocusFrame = requestAnimationFrame(() => {
              this.overlayActive && this.focusInitialOverlayControl();
            })));
        });
      }));
  }
  mountMobileOverlay() {
    !this.isMobileViewport() ||
      this.mobileOverlayMounted ||
      (this.sizeBackdrop && document.body.appendChild(this.sizeBackdrop),
      this.sizeOverlay && document.body.appendChild(this.sizeOverlay),
      document.body.classList.add('card-size-sheet-open'),
      (this.mobileOverlayMounted = !0));
  }
  unmountMobileOverlay() {
    this.mobileOverlayMounted &&
      (this.sizeBackdrop && this.sizeBackdropParent && this.sizeBackdropParent.appendChild(this.sizeBackdrop),
      this.sizeOverlay && this.sizeOverlayParent && this.sizeOverlayParent.appendChild(this.sizeOverlay),
      document.body.classList.remove('card-size-sheet-open'),
      (this.mobileOverlayMounted = !1));
  }
  isMobileViewport() {
    var e;
    return (
      ((e = this.mobileMediaQuery) == null ? void 0 : e.matches) ?? window.matchMedia(`(max-width: ${J - 1}px)`).matches
    );
  }
  onViewportChange() {
    this.overlayActive
      ? this.closeSizeOverlay({immediate: !0})
      : (this.unmountMobileOverlay(), this.releaseBackgroundIsolation());
  }
  closeSizeOverlay({immediate: e = !1, restoreFocus: t = !0} = {}) {
    var r, s;
    if (!this.sizeOverlay || !this.isSizeOverlayOpen()) return;
    clearTimeout(this.overlayCloseTimer),
      (this.overlayCloseTimer = null),
      clearTimeout(this.overlayFinishTimer),
      cancelAnimationFrame(this.overlayOpenFrame),
      cancelAnimationFrame(this.overlayVisibleFrame),
      cancelAnimationFrame(this.overlayFocusFrame),
      (this.overlayActive = !1),
      this.sizeOverlay.classList.remove(v.overlayOpen),
      (r = this.sizeBackdrop) == null || r.classList.remove(v.backdropOpen),
      this.classList.remove(v.cardSizeOverlayOpen),
      (s = this.sizeOverlayTrigger) == null || s.setAttribute('aria-expanded', 'false'),
      this.sizeOverlayTrigger && (this.sizeOverlayTrigger.hidden = !1),
      this.unbindOverlayDismissListeners();
    const i = () => {
      var n, a;
      this.overlayTransitionHandler &&
        (this.sizeOverlay.removeEventListener('transitionend', this.overlayTransitionHandler),
        (this.overlayTransitionHandler = null)),
        clearTimeout(this.overlayFinishTimer),
        (this.overlayFinishTimer = null),
        !this.overlayActive &&
          (this.sizeOverlay.setAttribute('hidden', ''),
          this.sizeOverlay.removeAttribute('aria-modal'),
          (n = this.sizeBackdrop) == null || n.setAttribute('hidden', ''),
          this.unmountMobileOverlay(),
          this.releaseBackgroundIsolation(),
          t &&
            (a = this.overlayReturnFocus) != null &&
            a.isConnected &&
            this.overlayReturnFocus.focus({preventScroll: !0}),
          (this.overlayReturnFocus = null));
    };
    if (
      ((this.overlayTransitionHandler = (n) => {
        n.target !== this.sizeOverlay || n.propertyName !== 'transform' || i();
      }),
      e)
    ) {
      i();
      return;
    }
    this.sizeOverlay.addEventListener('transitionend', this.overlayTransitionHandler),
      (this.overlayFinishTimer = window.setTimeout(i, se + 50));
  }
  isSizeOverlayOpen() {
    return !!this.overlayActive;
  }
  focusInitialOverlayControl() {
    var r, s;
    const e = (r = this.sizeOverlay) == null ? void 0 : r.querySelector(`${f.sizeOverlayClose}:not([disabled])`),
      t = (s = this.sizeOverlay) == null ? void 0 : s.querySelector(`${f.sizeOption}:not([disabled])`),
      i = e && !e.closest('[hidden]') ? e : t || this.sizeOverlay;
    i == null || i.focus({preventScroll: !0});
  }
  getOverlayFocusableElements() {
    return this.sizeOverlay
      ? Array.from(
          this.sizeOverlay.querySelectorAll(
            'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
          )
        ).filter((e) => !e.closest('[hidden]') && e.getAttribute('aria-hidden') !== 'true')
      : [];
  }
  isolateBackground() {
    !this.mobileOverlayMounted ||
      this.backgroundInertElements ||
      ((this.backgroundInertElements = Array.from(document.body.children).filter(
        (e) => e instanceof HTMLElement && e !== this.sizeOverlay && e !== this.sizeBackdrop && !e.hasAttribute('inert')
      )),
      this.backgroundInertElements.forEach((e) => e.setAttribute('inert', '')));
  }
  releaseBackgroundIsolation() {
    var e;
    (e = this.backgroundInertElements) == null || e.forEach((t) => t.removeAttribute('inert')),
      (this.backgroundInertElements = null);
  }
  onDocumentClick(e) {
    var i;
    if (!this.isSizeOverlayOpen()) return;
    const t = e.target;
    t instanceof Element &&
      (((i = this.sizeOverlay) != null && i.contains(t)) ||
        (this.contains(t) && (t.closest(f.sizeOverlayTrigger) || t.closest(f.swatches))) ||
        this.closeSizeOverlay());
  }
  onKeydown(e) {
    var n, a, c, l;
    if (!this.isSizeOverlayOpen()) return;
    if (e.key === 'Escape') {
      e.preventDefault(), this.closeSizeOverlay();
      return;
    }
    if (e.key !== 'Tab' || ((n = this.sizeOverlay) == null ? void 0 : n.getAttribute('aria-modal')) !== 'true') return;
    const t = this.getOverlayFocusableElements();
    if (!t.length) {
      e.preventDefault(), (a = this.sizeOverlay) == null || a.focus();
      return;
    }
    const i = t[0],
      r = t[t.length - 1],
      s = document.activeElement;
    e.shiftKey && (s === i || !((c = this.sizeOverlay) != null && c.contains(s)))
      ? (e.preventDefault(), r.focus())
      : !e.shiftKey &&
        (s === r || !((l = this.sizeOverlay) != null && l.contains(s))) &&
        (e.preventDefault(), i.focus());
  }
}
window.addEventListener('pageshow', () => {
  document.querySelectorAll('product-card[aria-busy="true"]').forEach((S) => {
    var e, t;
    (e = S.cancelConnectedProductRequest) == null || e.call(S),
      (t = S.restoreConnectedSwatchSelection) == null || t.call(S);
  });
});
customElements.get('product-card') || customElements.define('product-card', oe);
